import { QUERY_BREAK_POINT, BREAK_POINT_ORDER } from '../constants/breakpoint';
import useMediaQuery from './useMediaQuery';

/**
 * @param {{'2xl': any, xl: any, lg: any, md: any, sm: any, base: any}} [breakPointValue]
 */
const useBreakPointValue = (breakPointValue = {}) => {
  const matches = useMediaQuery(QUERY_BREAK_POINT);

  const matchedIndex = matches.findIndex(match => match === true);
  const matchedQuery = BREAK_POINT_ORDER[matchedIndex];

  // TODO:: Implement get closest value, but I think it not really helpful in ourcase. - @wesley.loh
  return breakPointValue[matchedQuery];
};

export default useBreakPointValue;
